// Admin Actions
export const ADMIN_TYPES = {
  // Tutorial Status
  UPDATE_TUTORIAL_STATUS: "UPDATE_TUTORIAL_STATUS",
  GET_ADMIN_SUBSCRIPTION: "GET_ADMIN_SUBSCRIPTION",
  GET_ADMIN_ANALYTICS: "GET_ADMIN_ANALYTICS",
};
